<div class="form-group me-lg-3">
  <div class="quantity-select-container">
    <div class="quantity">
      <!-- Minus Button -->
      <button
        class="btn number-input-decrement-button py-0 px-1"
        (click)="decrement.next(incrementValue)"
        attr.aria-label="{{ 'number.input.decrease.screenreader' | translate }}"
        [disabled]="
          ((limitValueToRange || limitValueToRange === undefined) && innerValue <= minValue) ||
          innerValue <= 1 ||
          !isActive ||
          control?.disabled
        "
      >
        <span class="material-icons material-symbols-outlined d-flex justify-content-center align-items-center"> remove </span>
      </button>
      <!-- Input Field -->
      <input
        id="amountInput"
        type="number"
        [(ngModel)]="innerValue"
        (keydown)="onNumberKeydown($event)"
        class="form-control bid-amount-input px-4 text-center"
        min="{{ minValue }}"
        max="{{ maxValue }}"
        [disabled]="!isActive || control?.disabled || innerValue === 0"
        #input
      />
      <span class="number-input-unit-label" *ngIf="unitLabel">{{ unitLabel }}</span>
      <!-- Plus Button -->
      <button
        class="btn number-input-increment-button py-0 px-1"
        (click)="increment.next(incrementValue)"
        attr.aria-label="{{ 'number.input.increase.screenreader' | translate }}"
        [disabled]="
          ((limitValueToRange || limitValueToRange === undefined) && innerValue >= maxValue) || !isActive || control?.disabled
        "
      >
        <span class="material-icons material-symbols-outlined d-flex justify-content-center align-items-center"> add </span>
      </button>
    </div>
  </div>
</div>

<!-- Errors-->
<div class="errors" *ngIf="showErrorMessage">
  <p class="error" id="minMessage" *ngIf="showMinMessage && minMessage">* {{ minMessage }}</p>
  <p class="error" id="maxMessage" *ngIf="showMaxMessage && maxMessage">* {{ maxMessage }}</p>
</div>
